import React, { useState } from 'react';
import { SchoolSnapshotKPIs } from './SchoolSnapshotKPIs';
import { SubjectAvgCards } from './SubjectAvgCards';
import { SubjectReadinessCards } from './SubjectReadinessCards';
import { GradeAvgCards } from './GradeAvgCards';
import { BranchLeaderboard } from './BranchLeaderboard';
import { SectionPerformanceTable } from './SectionPerformanceTable';
import { AchievementMatrixTable } from './AchievementMatrixTable';
import { TierDrilldownModal } from './TierDrilldownModal';

export const PerformanceOverviewTab = ({ onViewReport }) => {
  const [activeDrilldown, setActiveDrilldown] = useState(null);

  const handleDrilldown = (filter) => {
    setActiveDrilldown(filter);
  };

  const handleCloseDrilldown = () => {
    setActiveDrilldown(null);
  };

  return (
    <section id="overview" className="section-content">
      {/* Section Header */}
      <div className="mb-6">
        <h2 className="text-3xl font-bold text-gray-800" id="overview-section-title">
          Performance Overview
        </h2>
        <p className="text-sm text-gray-600 mt-1">
          Key metrics and overall performance summary
        </p>
      </div>

      {/* School Snapshot KPIs (5 cards) */}
      <SchoolSnapshotKPIs onDrilldown={handleDrilldown} />

      {/* Subject-wise Average Score */}
      <SubjectAvgCards />

      {/* Subject Readiness Distribution */}
      <SubjectReadinessCards />

      {/* Grade-wise Average Score */}
      <GradeAvgCards />

      {/* Branch Performance Leaderboard */}
      <BranchLeaderboard />

      {/* Section-wise Performance (Scoped mode only) */}
      <SectionPerformanceTable />

      {/* Achievement Level — By School & Grade (English & Math Gap matrices) */}
      <AchievementMatrixTable onCellClick={handleDrilldown} />

      {/* Filtered Student List Drilldown */}
      {activeDrilldown && (
        <TierDrilldownModal
          filter={activeDrilldown}
          onClose={handleCloseDrilldown}
          onViewReport={(student) => {
            onViewReport(student);
          }}
        />
      )}
    </section>
  );
};
export default PerformanceOverviewTab;
